import client from '../session/apiClient'
import {chunk, flatten} from 'lodash'
import defaultSessionStore, {SessionStore} from "../session/SessionStore";

export function listUsers({
  query = undefined,
  offset = 0, limit = 100
}) {
  return client.get('/v5/users', { params: {
    query, limit, offset, skipLocationTotals: true
  }})
    .then(({data: { hasMore, users }}) => {
      return ({ hasMore, users: users })
    })
}

export function listWorkflowUsers({
  query = undefined,
  offset = 0, limit = 100

}) {
  return client.get('/v5/workflowUsers', { params: {
      query, limit, offset, skipLocationTotals: true
    }})
      .then(({data: { hasMore, users }}) => {
        return ({ hasMore, users: users })
      })
}

export function listSocialDraftUsers({
  query = undefined,
  offset = 0, limit = 100

}) {
  return client.get('/v5/socialDraftUsers', { params: {
      query, limit, offset, skipLocationTotals: true
    }})
      .then(({data: { hasMore, users }}) => {
        return ({ hasMore, users: users })
      })
}

export function getUsers(userId) {
  return client.get('/v5/users', {
    params: {
      userId,
      skipLocationTotals: true,
      limit: (userId && userId.length ? userId.length : 1)
    }})
    .then((resp) => resp.data);
}

/** @returns {Promise.<UserPreferences>} */
export function userPreferences(userId) {
  return client.get(`/v5/user/preferences`, {params: {userId}})
}

export function upsertUserPreferences({userId, userPreferences}){
  return client.post(`/v5/user/preferences/${userId}`, userPreferences )
}

export function markAsShown(userguidingId){
  const userPrefs = defaultSessionStore.userPreferences
  userPrefs.seenGuides.push(userguidingId)
  upsertUserPreferences({userId: userPrefs.userId, userPreferences: userPrefs})
}

export function userSummaries(userId, includeCancelled) {

  const chunked = chunk(userId, 50) // Long query strings break

  const chunkedPromises = chunked.map(chunk => client.get('/userSummaries', { params: {
    userId: chunk,
    includeCancelled: true
  } }).then(x => x.data))

  return Promise.all(chunkedPromises)
      .then(flatten)
}


export function getUserRoles() {
  return client.get('/v5/userRoles').then(response => response.data);
}

/** @typedef {object} UserPreferences
 *
 * @property {string} userId: String,
 * @property [*] favoriteCustomReports - a Map[String, DateTime]
 * @property {number[]} seenGuides - a Set[Int] of user guiding guide ids
 * @property {boolean} [stickyUrl] - whether to retain url on login
 * @property {string} [persona] - type of user as filled out in modal prompt on login
 * @property {boolean} [useNewLayout] - is the user on the new layout?
 * @property {boolean} [hasOptedIntoNewLayout] - has the user tried out the new layout?
 */
